import { useMemo } from 'react';

import { orderBy } from 'lodash';
import { Controller } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { IAllUserGroups, useQueryGetAllUserGroups } from 'api/queries/getAllUserGroups.query';

import { Select } from 'components/DesignSystem/Select';
import classes from 'components/Settings/Components/UserProfile/components/userProfile.module.scss';
import { IUserGroups } from 'components/Settings/Components/UserProfile/userProfile.utils.type';
import { CustomizedFormErrorMessage } from 'components/common';

const groupsMapper = (item: IAllUserGroups) => ({ value: item.group_id, label: item.group_name });

export const UserGroups = ({ errors, control }: IUserGroups) => {
    const { ability } = useUserHook();
    const { data: userGroups } = useQueryGetAllUserGroups({ enabled: ability.can('view', 'UserManagement') });
    const options = useMemo<ISelectOption<number>[]>(() => {
        return userGroups
            ? orderBy(
                  userGroups.map(groupsMapper),
                  [(item: ISelectOption<number>) => item['label'].toLowerCase()],
                  ['asc'],
              )
            : [];
    }, [userGroups]);
    return (
        <div data-testid={'user-groups'} className={classes.associatedRolesContainer}>
            <label>User Groups*</label>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<number>, true>
                        {...field}
                        options={options}
                        isClearable={true}
                        isMulti
                        menuPlacement={'auto'}
                    />
                )}
                name={'userGroups'}
                control={control}
                rules={{
                    validate: {
                        required: (value) => value.length > 0 || 'Must select at least one user groups',
                    },
                }}
            />

            {errors.userGroups && <CustomizedFormErrorMessage text={errors.userGroups.message} />}
        </div>
    );
};
